import { AnyObject } from 'zf-types';
import { CustomDescriptor } from './types';


export function modify<Target, Params extends unknown[], Return>(property = 'modified') {
  return function(target: Target, context: ClassMethodDecoratorContext): CustomDescriptor<Return> {
    if (context.kind !== 'method') {
      return;
    }

    return async function(this: AnyObject, ...args: Params): Promise<Return> {
      try {
        return await ((target as AnyObject).apply(this, args) as Promise<Return>);
      } finally {
        this[property] = true;
      }
    };
  };
}


